import moment from 'moment';

export const getAllEventDates = (events: any[]): Date[] => {
	let dates: Date[] = [];
	events.map((event: any,index: number) => {
		dates = [...dates, ...getDates(event)];
	});
	return dates;
};

const getDates = (event: any): Date[] => {
	const dates = [];
	const daysBetween = moment(event.attributes.field_event_end_date).diff(
		event.attributes.field_event_start_date,
		'days',
	);

	for (let i = 0; i <= daysBetween; i++) {
		const date: any = moment(
			event.attributes.field_event_start_date,
			'YYYY-MM-DD',
		)
			.add(i, 'day')
			.format('DD/MM/YYYY');

		dates.push(date);
	}

	return dates;
};

export const getFilters = (filters: any): string =>
	Object.keys(filters)
		.map((filter) => {
			return `filter[${filter}]=${filters[filter]}`;
		})
		.join('&');
